export default __webpack_public_path__ + "static/manifold_w.96584358c32799aba3c2fe08abc056a1.svg";